export const iconStyles = {
  position: 'absolute',
  top: 3,
  left: 0
} as const
